import { selectUsers } from './chunk-YLY6KHID.mjs';

// src/helpers/register/drawers/drawers.ts
var drawersAndBanksModalOptions = (drawers, state, currentDrawer) => {
  const users = selectUsers(state);
  let options = [];
  Object.values(drawers).forEach(({ id, status }) => {
    var _a;
    if (status === "closed" /* CLOSED */) {
      return;
    }
    const drawer = drawers[id];
    options.push({
      label: drawer.type === "server" /* SERVER */ ? ((_a = users[drawer.ownerOrganizationUserId]) == null ? void 0 : _a.posName) || drawer.name : drawer.name,
      value: Number(id),
      type: [drawer.type]
    });
  });
  options = options.filter((option) => option.value !== currentDrawer);
  return options;
};
var drawersModalOptions = (drawers, currentDrawer) => {
  let options = [];
  Object.values(drawers).forEach(({ id }) => {
    const drawer = drawers[id];
    if (drawer.type === "server" /* SERVER */)
      return;
    options.push({
      label: drawer.name,
      value: Number(id),
      type: [drawer.type]
    });
  });
  options = options.filter((option) => option.value !== currentDrawer);
  return options;
};

export { drawersAndBanksModalOptions, drawersModalOptions };
